import WebOttMenu from '@bnr-dev/menu/dist/index.js';
import {createApp, h, reactive} from 'vue';
import {fetchTranslations, initTranslations} from "@bnr-dev/translate";
import "@bnr-dev/menu/dist/index.css";
import commonFrontendTranslations from '../../../../public/json/common-frontend-translations.json';

const simpleLocalizeOttUiCommonToken = "871890add0b24067883679bea521b926";

let i18n;

const props = reactive({
    userEmail: undefined,
    moduleId: undefined,
    translate: (key) => i18n ? i18n.global.t(key) : key,
    loaded: false
});

const app = createApp({
    render: () => h(WebOttMenu, props)
});

app.provide('authService', {
    signOut: () => window.appController?.authService.signout(),
    isSignedIn: () => window.appController?.authService.isSignedIn()
});

app.provide('authorizationService', {
    userHasModule: (moduleId) => {
        return window.appController?.authorizationService?.userHasModule(moduleId);
    }
});

app.provide('tokenService', {
    getUserRole: () => window.appController?.tokenService.getUserRole(),
});

function updateUserEmail() {
    const tokenData = window.appController?.tokenService.getTokenData();
    if (tokenData) {
        props.userEmail = tokenData.userEmail;
    }
}

function setModuleId() {
    const hash = window.location.hash;
    if (!hash || hash.length < 3) {
        props.moduleId = undefined;
        return;
    }

    const endIndx = hash.indexOf('?');
    let path = endIndx > 0 ? hash.substring(2, endIndx) : hash.substring(2);
    path = path.toUpperCase().replace("-", "_");
    props.moduleId = path.toUpperCase();

    updateUserEmail();
}

function initApp(translationData) {
    i18n = initTranslations([translationData], window.languageCode.substr(0, 2));

    app.use(i18n);
    app.mount('#menu-app');

    setModuleId();
    hideIfMonitor();

    // React to URL changes
    window.addEventListener('popstate', () => {
        hideIfMonitor();
        setModuleId();
    });

    updateUserEmail();
    props.loaded = true;
}

function setup() {
    // Fetch translations in setup, to ensure languageCode is set
    fetchTranslations(simpleLocalizeOttUiCommonToken)
        .then(translationData => initApp(translationData))
        .catch(() => initApp(commonFrontendTranslations));
}

function hideIfMonitor() {
    const isMonitor = window.location.href.endsWith("/#/monitor");
    if (isMonitor) {
        document.getElementById("menu-app").style.display = "none";
    } else {
        document.getElementById("menu-app").style.display = "block";
    }
}

window.addEventListener('AppReady', setup);
